import React from 'react'; 
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from './store';
import history from 'common/history'
import {
    Link
} from 'react-router-dom';
import './index.css'
import Header from 'component/mobile_header' 
import Video from './components/mobileVideo'
import VideoTab from './components/videoTab'

import userRequest, { userApi } from 'common/request'

class LiveInfo extends React.Component{
  constructor(props){
    super(props);
    this.state={
      title:'直播视频',
      liveinfo: '',
      isLiveing: true
    }
  }
  componentWillMount(){
    this.getLiveInfo(this.props.match.params.id)
  }

  getLiveInfo = (course_id, user_id, username) => {
    userRequest.get(window.AppConfig.liveIP + userApi.getLiveInfo,{
            course_id,
            user_id:user_id||'',
            username:username||''
        }).then((res) => {
            /*if(res.code===0){
                dispatch(changeLiveInfo(res.data))
            } */
            this.setState({liveinfo: res.data})
    });
  }

  liveingHandle = (data) => {
      this.setState({isLiveing: data})
  }
  

  render(){ 
    const { liveinfo } = this.state
    return (
      <div> 
        <Header title = {this.state.title}/>
          <div className="container labinfo">
              <Video liveinfo={this.state.liveinfo} isLiveing={this.state.isLiveing}/>
            <div className="video-title">
              <span>
                {
                  liveinfo&&liveinfo.title?
                  liveinfo.title:
                  '暂无'
                }
              </span>
              {/*<div className='videoInfo' dangerouslySetInnerHTML={{__html: liveinfo.toJS().course_info&&liveinfo.toJS().course_info.content}} />*/}
            </div>
            { liveinfo&&liveinfo.live&&liveinfo.live.room_id ? <VideoTab liveinfo={this.state.liveinfo} liveingHandle={this.liveingHandle}/> : null}
           </div>  
      </div>
      )
  }
}
const mapState = (state) => ({ 
})
 
const mapDispatch = (dispatch) => ({
})
export default connect(mapState, mapDispatch)(LiveInfo);
